import { useCallback, useRef } from 'react';
import { useLifecycle } from './useLifecycle';

export function useDebounce(callback: (args: any) => void, delay: number) {
  const handlerRef = useRef<NodeJS.Timeout | null>(null);

  useLifecycle({
    onUnmount: () => {
      if (handlerRef.current) {
        clearTimeout(handlerRef.current);
      }
    },
  });

  return useCallback(
    (args: any) => {
      if (handlerRef.current) {
        clearTimeout(handlerRef.current);
      }

      handlerRef.current = setTimeout(() => {
        callback(args);
      }, delay);
    },
    [callback, delay],
  );
}
